import type { BookingHistoryItem } from "@/types/booking-history/bookinghistory";
import { safeFormatDateTime } from "@/utils/formatDate";
import { ArrowRight, ChevronRight } from "lucide-react";
import { Link } from "react-router";

type BookingHistoryCardProps = {
  booking: BookingHistoryItem;
};


export default function DesktopBookingHistoryList({ booking }: BookingHistoryCardProps) {
  return (
    <Link to={`/booking-history/${booking.paymentId}`}>
      <div className="grid grid-cols-10 items-center gap-4 bg-white py-3">
        <div className="text-base font-semibold text-heading">
          {booking.bookingNo}
        </div>
        <div className="text-sm font-medium flex text-primary col-span-3 items-center gap-1">
          {booking.origin} <ArrowRight size={14} /> {booking.destination}
        </div>
        <div className="text-sm font-medium text-secondary-foreground col-span-2">
          {safeFormatDateTime(booking.departureDate)}
        </div>
        <div className="text-sm font-medium text-secondary-foreground col-span-2">
          {booking.returnDate === "0001-01-01 00:00:00"
            ? "-"
            : safeFormatDateTime(booking.returnDate)}
        </div>
        <div className="text-sm font-medium text-secondary-foreground">
          {booking.passengerCount}
        </div>
        <div className="text-sm font-medium text-primary flex justify-center items-center gap-1">
          View <ChevronRight size={14} />
        </div>
      </div>
    </Link>
  );
}